export enum DeliveryStatus {
  SUCCEEDED = 'Succeeded',
  PENDING = 'Pending',
  FAILED = 'Failed',
  UNKNOWN = 'Unknown',
}
